import React, { Component } from 'react';
import logo from '../img/rat-logo.png';
import $ from 'jquery';
import Script from 'react-load-script';
import Helmet from 'react-helmet';

import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
var GifPlayer = require('react-gif-player');

class Gallery extends Component {


	componentDidMount(){
    $('body').bind('touchmove', function(event) { event.preventDefault() }); 
      autoPlayYouTubeModal();

       function autoPlayYouTubeModal() {
          var trigger = $("body").find('[data-toggle="modal"]');
          trigger.click(function () {
              var theModal = $(this).data("target"),
                  videoSRC = $(this).attr("data-thevideo"),
                  videoSRCauto = videoSRC + "?autoplay=1";
              $(theModal + ' .embed-responsive img').attr('src', videoSRC);
              $(theModal + ' button.close').click(function(){
                  $(theModal + ' .embed-responsive img').attr('src', '');
              });
              $('.modal').click(function () {
                  $(theModal + ' .embed-responsive img').attr('src', '');
              });
          });
        }
  }

	render() {
    return (
        <div>
              <Helmet
                title="RAT Films - Best Film Production Company in India"
                meta={[
                  { name: 'description', content: "RAT Films came into existence because of its commitment to deliver cutting-edge films with the hallmark of quality and film-making passion.    " },
                  

                  ]}
              />
    		  <div className="main-content">
            <section className="portfolio" >

                <div className="container thumb-cont">
                <h3 className="heading main">GALLERY</h3>

                	<div className="col-sm-3 thumb-item play-video" href="#" data-toggle="modal" data-target="#videoModal" data-theVideo={require('../img/pf_item_1.jpg')} >
                    <img className="thumb-img" src={require('../img/pf_item_1.jpg')}   alt=""/>
                    
                    <div className="overlay">
                      <div className="overlay-inner">
                       
                          
                        <div className="video-label">
                          <h2 className="ft-white link-text">Snickers Nautanki</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-3 thumb-item play-video" href="#" data-toggle="modal" data-target="#videoModal" data-theVideo={require('../img/Capture.jpg')}>
                       <img className="thumb-img" src={require('../img/Capture.jpg')}  alt=""/>
                   
                    <div className="overlay">
                      <div className="overlay-inner">
                        
                          
                        <div className="video-label">
                          <h2 className="ft-white link-text">Somany Promotion</h2>
                        </div>
                      </div>
                    </div>
                  </div>

              
            	</div>
            </section>
    		</div>




                <div className="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="videoModal" aria-hidden="true"  data-dismiss="modal">
                    <div className="vertical-align" data-dismiss="modal" aria-hidden="true">
                      <div className="modal-dialog vertical-align-center">
                          <div className="modal-content modal-content-bg">
                              <div className="modal-body">
                                  <a href="#" className="close-video" data-dismiss="modal" aria-hidden="true"><img src={require('../img/close.png')} /></a>
                                  <div>
                                     <div className="embed-responsive embed-responsive-4by3">
                                       <img class="full-image" src="" />
                                     </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>


        

		
    );
  }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/gallery.js